import { createSlice } from '@reduxjs/toolkit';

import {
    initAppData,
    initAppDataFulfilled,
    initAppDataRejected,
} from '../listeners/init-app-data';
import type { AppDataSchema } from '../types/app-data.schema';

const initialState: AppDataSchema = {
    status: 'init',
};

const appDataSlice = createSlice({
    name: 'appData',
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(initAppData, (state) => {
                state.status = 'loading';
            })
            .addCase(initAppDataFulfilled, (state) => {
                state.status = 'success';
            })
            .addCase(initAppDataRejected, (state) => {
                state.status = 'error';
            }),
});

export const { reducer: appDataReducer } = appDataSlice;
